<template>
  <!--vue-js-modal-->
  <modal
    :height="'90%'"
    v-bind="$attrs"
    :adaptive="true"
    v-on="listeners"
  >
    <slot />
  </modal>
</template>

<script>
const MOBILE_BREAKPOINT = 743

// vue-js-modal sets inline top/left/width/height on .vm--modal from cached
// viewport dimensions. When the viewport is resized from desktop to mobile
// via DevTools (without a reload), those inline values can be stale and
// fight the ≤743px CSS overrides. Clearing them lets the media-query
// !important rules position/size the modal on their own.
function clearMobileInlineStyles (rootEl) {
  if (!rootEl || window.innerWidth > MOBILE_BREAKPOINT) return
  ;['top', 'left', 'right', 'bottom', 'width', 'height', 'margin', 'transform'].forEach(prop => {
    rootEl.style[prop] = ''
  })
}

export default {
  name: 'PModal',
  data () {
    return {
      openModalEl: null
    }
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        opened: this.handleOpened,
        'before-close': this.handleBeforeClose
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  methods: {
    handleOpened (event) {
      this.openModalEl = event && event.ref ? event.ref : document.querySelector('.vm--modal')
      clearMobileInlineStyles(this.openModalEl)
      window.addEventListener('resize', this.handleWindowResize)
      if (this.$listeners.opened) this.$listeners.opened(event)
    },
    handleBeforeClose (event) {
      window.removeEventListener('resize', this.handleWindowResize)
      this.openModalEl = null
      if (this.$listeners['before-close']) this.$listeners['before-close'](event)
    },
    handleWindowResize () {
      clearMobileInlineStyles(this.openModalEl)
    }
  }
}
</script>
